/* eslint-disable max-len */
import { Form, Row } from 'antd';
import { UploadChangeParam } from 'antd/es/upload';
import React, { useContext, useState } from 'react';
import { ILeiData } from 'types/leiTypes';

import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import UploadComponent, { IFileList } from 'components/atoms/UploadComponent';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { leiPrevodPDF } from 'services/lei/leiTransfer';

interface IPodpis {
    prevStep: () => void;
    nextStep: () => void;
    setFormData: React.Dispatch<React.SetStateAction<ILeiData | undefined>>;
    isPrehled?: boolean;
    formData?: ILeiData;
}

export interface IPodpisFileList extends IFileList {
    tempnazev: string;
}

const Podpis: React.FC<IPodpis> = ({ prevStep, nextStep, setFormData, isPrehled, formData }) => {
    const { lei } = useContext(Context);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [fileList, setFileList] = useState<IPodpisFileList[]>(
        formData?.soubor
            ? [
                  {
                      uid: '',
                      name: formData?.soubor.orignazev,
                      fileName: formData?.soubor.orignazev,
                      status: 'done',
                      type: '',
                      size: 0,
                      tempnazev: formData?.soubor.tempnazev
                  }
              ]
            : []
    );
    // const [signType, setSignType] = useState<string>();

    const uploadPropsPotvrzeni = {
        id: 'potvrzeniDownloadBtn',
        showDownloadIcon: false,
        onChange: (upldata: UploadChangeParam) => {
            if (upldata.fileList) {
                upldata.fileList.length && setLoading(true);
                setFileList(
                    upldata.fileList
                        .filter(f => f.status && f.status !== 'error')
                        .map(e => {
                            return {
                                uid: e.uid,
                                name: e.name.normalize(),
                                fileName: e.fileName ? e.fileName : e.response ? e.response.tempnazev : '',
                                type: e.type!,
                                size: e.size!,
                                status: e.status ? e.status : 'error',
                                tempnazev: e.response && e.response?.tempnazev ? e.response.tempnazev : undefined
                            };
                        })
                );
                setTimeout(() => form.validateFields(['potvrzeni']), 100);
            }
            if (upldata.file.response) {
                setLoading(false);
            }
        },
        onRemove: () => {
            setFileList([]);
        },
        fileList: fileList,
        buttonDisabled: !!fileList.length
    };

    return (
        <LoadingWrapper loading={loading}>
            <Title text="PODPIS" level={5} dividerTitle={true} />
            <FormWrapper
                outForm={form}
                onFinish={() => {
                    setFormData(pv => {
                        return {
                            ...pv,
                            soubor: {
                                orignazev: fileList[0].name,
                                tempnazev: fileList[0].tempnazev
                            }
                        };
                    });
                    nextStep();
                }}
                name="Osoby"
            >
                <>
                    {/*   <InputComponent
                        label="JMENO"
                        name="jmeno"
                        initialValue={profily?.jmeno}
                        disabled={true}
                        notRequired={true}
                    />
                    <InputComponent
                        label="PRIJMENI"
                        name="prijmeni"
                        initialValue={profily?.prijmeni}
                        disabled={true}
                        notRequired={true}
                    />
                    <InputComponent
                        label="EMAIL"
                        name="email"
                        initialValue={profily?.email}
                        disabled={true}
                        notRequired={true}
                    />
                    <InputComponent
                        label="TELEFON"
                        name="telefon"
                        type="tel"
                        initialValue={profily?.telefon1}
                        disabled={true}
                        notRequired={true}
                    />

                   <SelectComponent
                            labelParagraph="ZPUSOB_PODEPSANI"
                            onChange={val => setSignType(val)}
                            isFormItem={true}
                            name="typpodpisu"
                            // defaultValue={jinaOsobaData?.podpisData?.typpodpisu}
                            data={[
                                {
                                    labelcz: 'CERTIFIKAT',
                                    value: 'CERT'
                                },
                                {
                                    labelcz: 'BISIGN',
                                    value: 'BI'
                                },
                                {
                                    labelcz: 'VLASTNORUCNI_PODPIS',
                                    value: 'PODPIS'
                                }
                            ]}
                            disabled={isSigned}
                        /> */}

                    <>
                        <ButtonComponent
                            buttontext={'PODEPSAT_CERT_BTN'}
                            id="OsobyCertBtn"
                            type="primary"
                            style={{
                                marginTop: 6
                            }}
                            onClick={() => {
                                setLoading(true);
                                leiPrevodPDF(
                                    lei?.idVarsymZadosti?.varsym!,
                                    lei?.idVarsymZadosti?.id!,
                                    `${lei?.prevodData?.spolecnost?.legalentityidentifier}_TRANSFER.pdf`
                                ).finally(() => setLoading(false));
                            }}
                            disabled={isPrehled}
                        />
                        <div>
                            <Form.Item
                                style={{
                                    marginBottom: 16
                                }}
                                id="potvrzeni"
                                name="potvrzeni"
                                label={<Paragraph text={'FORMULARE_PODEPSANY_SOUBOR'} strong={true} />}
                                rules={[
                                    {
                                        required: true,
                                        validator() {
                                            try {
                                                if (fileList.length < 1)
                                                    return Promise.reject(
                                                        <TranslateText>NEVALIDNI_POVINNA_POLOZKA_UPLOAD</TranslateText>
                                                    );
                                                return Promise.resolve();
                                            } catch {
                                                return Promise.reject();
                                            }
                                        }
                                    }
                                ]}
                            >
                                <div
                                    style={{
                                        marginBottom: 22
                                    }}
                                >
                                    <UploadComponent
                                        {...uploadPropsPotvrzeni}
                                        // uploadPath={mode === 'smsLogin' ? apiPaths.FILE_UPLOAD_AMLODKAZ : ''}
                                    />
                                </div>
                            </Form.Item>
                        </div>
                    </>
                </>

                {!isPrehled && (
                    <Row
                        style={{
                            marginTop: 20
                        }}
                    >
                        <ButtonComponent
                            buttontext="ZPET"
                            onClick={() => prevStep()}
                            id="OsobyZpetBtn"
                            type="default"
                        />
                        <ButtonComponent
                            buttontext={'POKRACOVAT'}
                            id="OsobyPokracovatBtn"
                            style={{
                                margin: '0 8px'
                            }}
                            htmlType="submit"
                            type="primary"
                        />
                    </Row>
                )}
            </FormWrapper>
        </LoadingWrapper>
    );
};

export default Podpis;
